var map = {
	"./beach_1.jpg": 320,
	"./beach_2.jpg": 103,
	"./beach_3.jpg": 321,
	"./beach_4.jpg": 322,
	"./beach_5.jpg": 323,
	"./beach_6.jpg": 324,
	"./beach_7.jpg": 325,
	"./boats_1.jpg": 326,
	"./crater_1.jpg": 327,
	"./marine_1.jpg": 328,
	"./marine_2.jpg": 329,
	"./marine_3.jpg": 330,
	"./monument_1.jpg": 331,
	"./road_1.jpg": 332,
	"./rockfield.jpg": 333,
	"./rockfield_2.jpg": 334,
	"./rockfield_3.jpg": 335,
	"./rockfield_4.jpg": 336,
	"./rockfield_5.jpg": 337,
	"./volcano_1.jpg": 338,
	"./waterfall.jpg": 339
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 349;



//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stock/mauritius nonrecursive \.(png|jpe?g|svg)$
// module id = 349
// module chunks = 0